import { useNavigate } from "@tanstack/react-router";
import type { Category } from "@instead/shared";
import { ItemForm, type Prefill } from "../components/ItemForm.tsx";

/** Prefill from the share target (§3.1: ?title=&text=&url=) or the quick
 *  entry (round 5: also desc, thumb, cat for a book found by ISBN). */
function prefillFromUrl(): Prefill {
  const q = new URLSearchParams(window.location.search);
  const text = q.get("text") ?? "";
  const url = q.get("url") ?? (/^https?:\/\/\S+$/.test(text) ? text : "");
  const cat = q.get("cat");
  return {
    title: q.get("title") ?? "",
    link: url,
    ...(q.get("desc") ? { description: q.get("desc")! } : {}),
    ...(q.get("thumb") ? { thumbUrl: q.get("thumb")! } : {}),
    ...(cat ? { categoryKind: cat as Category["kind"] } : {}),
  };
}

export function AddItem() {
  const nav = useNavigate();
  const pre = prefillFromUrl();
  return (
    <ItemForm prefill={pre} onDone={(saved) => void nav(saved ? { to: "/item/$id", params: { id: saved.id } } : { to: "/shelf" })} />
  );
}
